import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920
};

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      servicesSize: 4,
      ordersChartReady: false,
      ordersToDisplayInChart: 6,
      fieldStates: [],
      ICC: "",
      confirmICC: "", //ICC del envío
      fieldsToValidateSIMDelivery: ["ICC"],
      confirmingDelivery: ""
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.refreshInternet = this.refreshInternet.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSIMDelivery = this.validateSIMDelivery.bind(this);
    this.createConfirmSIMDeliveryPopUp = this.createConfirmSIMDeliveryPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateICC(icc) {
    return icc === this.state.confirmICC.substring(this.state.confirmICC.length - 4);
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  validateSIMDelivery() {
    let validation = true;
    this.state.fieldsToValidateSIMDelivery.map((item,key) => 
    {
      this.validateField(item, this.state[item]);
      if (this.state.fieldStates[item] === "has-danger") validation = false;
      if (!this.state[item] || this.state[item] === "") {
        validation = false;
      }
    });
    return validation;
  }
  deliverySIMConfirmation() {
    if (!this.validateSIMDelivery()) {
      return;
    }
    this.props.confirmSIMDelivery(this.state.confirmingDelivery);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block"/*, marginTop: "-250px" */}}
          title="¡Recepción confirmada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Hemos lanzado tu portabilidad, en 36-48h hábiles (sin contar festivos ni fines de semana) estará lista.
        </SweetAlert>
      )
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createConfirmSIMDeliveryPopUp() {
    return (
      <SweetAlert
        style={{ display: "block"/*, marginTop: "-250px"*/ }}
        title="Confirmar SIM"
        onConfirm={() => this.showPopUpConfirmation(CONFIRMAR_SIM)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row className="text-center">
            <div style={{margin: "0 2em 1em 2em", textAlign: "justify"}}>
              <span>Para confirmar la recepción de la SIM, escribe los 4 últimos números de la ICC de la SIM (Los 4 últimos números del código de barras)</span>
            </div> 
            <Col xs={12} md={9}>
              <FormGroup className={this.state.fieldStates["ICC"]}>
                <Input
                  type="number"
                  value={this.state.ICC}
                  onChange={event => {
                    this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                    this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                  }}
              />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    }

    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        moment(currentOrder.fecha, "YYYY/MM/DD").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    if(this.props.mainState.hasMobile && this.props.mainState.mobilesLoaded){      
      mobileContent = this.props.mainState.mobiles.map((currentMobile, key) =>{
        return (
          <Col key={currentMobile.mobile} xs={12} md={this.state.servicesSize}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={this.props.mainState.mobilesCDRLoaded ? "/movil/" + currentMobile.mobile : "/movil"}>
                      <Statistics
                        showIcon
                        iconState="primary"
                        icon="tech_mobile"
                        title={currentMobile.mobile.substring(0,3) + " " + currentMobile.mobile.substring(3,6) + " " + currentMobile.mobile.substring(6,9)}
                        subtitle={currentMobile.plan.replace(" (Móvil)", "")}
                      />
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    }else if(this.props.mainState.mobilesLoaded){
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="tech_mobile"
                    title="Móviles"
                    subtitle="¡Trae tus móviles!"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Móviles"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return mobileContent;
  }
  createInternetCards() {
    let internetContent = null;
    if(this.props.mainState.hasInternet && this.props.mainState.internetLoaded){      
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="primary"
                    icon="location_world"
                    title="Internet"
                    subtitle={this.props.mainState.internet_plan.name}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else if(this.props.mainState.internetLoaded){
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="location_world"
                    title="Internet"
                    subtitle="Sin conexión en casa..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Internet"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return internetContent;
  }
  createSIMDeliveriesCards() {
    let SIMDeliveriesContent = null;
    if(this.props.mainState.SIMDeliveries.length > 0){      
      SIMDeliveriesContent = this.props.mainState.SIMDeliveries.map(delivery => {
        let formattedNumber =
          delivery.numero_movil.substring(0, 3) +
          " " +
          delivery.numero_movil.substring(3, 6) +
          " " +
          delivery.numero_movil.substring(6, 9);
        
        let _isConfirmingSIMDelivery = false;
        if (delivery in this.props.mainState.isConfirmingSIMDelivery && 
          this.props.mainState.isConfirmingSIMDelivery[delivery]) {
            _isConfirmingSIMDelivery = true;
        }

        return(
          <Col key={delivery.id} xs={12} md={this.state.servicesSize}>
            <Card 
              className="card-stats card-raised" 
              color="primary"
              onClick={() => {
                if (!_isConfirmingSIMDelivery) {
                  this.showPopUp(CONFIRMAR_SIM);
                  this.setState({
                    confirmICC: delivery.icc,
                    confirmingDelivery: delivery.id
                  });
                }
              }}>
              <CardHeader>
                <div>
                  <span className="text-center" style={{color: "#FFF"}}>Pulsa para confirmar la recepción</span>
                </div> 
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Statistics
                      showIcon
                      iconState="info"
                      icon={_isConfirmingSIMDelivery? "arrows-1_refresh-69 spin" : "shopping_delivery-fast"}
                      subtitle={<span style={{color: "#FFF"}}>SIM para el número</span>}
                      title={formattedNumber}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>);
      });
      SIMDeliveriesContent = <Row>{SIMDeliveriesContent}</Row>;
    }
    return SIMDeliveriesContent;
  }
  refreshInternet() {
    /* //console.log("################ REFRESH INTERNET ###############"); */
    this.props.loadInternet();
  }
  render() {
    if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady) this.loadOrdersChart();
    return (
      <div>
        <PanelHeader
          size="lg"
          content={
            <div>
              <h6 style={dashboardOrdersTitleStyle}>Últimas facturas</h6>
            <Line
              data={!this.state.ordersChartReady? dashboardPanelChart.data : this.state.ordersChart.data}
              options={!this.state.ordersChartReady? dashboardPanelChart.options : this.state.ordersChart.options}
            />
            </div>
          }
        />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          {this.createSIMDeliveriesCards()}
          <Row>
            {this.createInternetCards()}
            {this.createMobileCards()}
          </Row>
          {/* <Row>
            <Card> 
              <CardBody>
                <Button
                  color="info"
                  size="primary"
                  onClick={e =>
                    this.addSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-add" />
                  </div>
                </Button>{"  "}
                <Button
                  color="danger"
                  size="sm"
                  onClick={e =>
                    this.subSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-delete" />
                  </div>
                </Button>{"  "}
                <Button
                  color="info"
                  size="sm"
                  onClick={e =>
                    this.refreshInternet()
                  }
                >
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69" />
                  </div>
                </Button>
              </CardBody>
            </Card> 
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="primary"
                        icon="ui-2_chat-round"
                        title="859"
                        subtitle="Messages"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="success"
                        icon="business_money-coins"
                        title={
                          <span>
                            <small>$</small>3,521
                          </span>
                        }
                        subtitle="Today Revenue"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="info"
                        icon="users_single-02"
                        title="562"
                        subtitle="Customers"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="danger"
                        icon="objects_support-17"
                        title="353"
                        subtitle="Support Requests"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Users</CardCategory>
                  <CardTitle tag="h2">34,252</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveUsersChart.data}
                      options={dashboardActiveUsersChart.options}
                    />
                  </div>
                  <Table responsive>
                    <tbody>{this.createTableData()}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Summer Email Campaign</CardCategory>
                  <CardTitle tag="h2">55,300</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardSummerChart.data}
                      options={dashboardSummerChart.options}
                    />
                  </div>
                  <div className="card-progress">
                    <Progress badge="Delivery Rate" value="90" />
                    <Progress color="success" badge="Open Rate" value="60" />
                    <Progress color="info" badge="Click Rate" value="12" />
                    <Progress color="primary" badge="Hard Bounce" value="5" />
                    <Progress color="danger" badge="Spam Report" value="0.11" />
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Countries</CardCategory>
                  <CardTitle tag="h2">105</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveCountriesCard.data}
                      options={dashboardActiveCountriesCard.options}
                    />
                  </div>
                  <VectorMap
                    map={"world_mill"}
                    backgroundColor="transparent"
                    zoomOnScroll={false}
                    containerStyle={{
                      width: "100%",
                      height: "280px"
                    }}
                    containerClassName="map"
                    regionStyle={{
                      initial: {
                        fill: "#e4e4e4",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0
                      }
                    }}
                    series={{
                      regions: [
                        {
                          values: mapData,
                          scale: ["#AAAAAA", "#444444"],
                          normalizeFunction: "polynomial"
                        }
                      ]
                    }}
                  />
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[{ i: "now-ui-icons ui-2_time-alarm", t: "Last 7 days" }]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Best Selling Products</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive className="table-shopping">
                    <thead>
                      <tr>
                        <th className="text-center" />
                        <th>PRODUCT</th>
                        <th>COLOR</th>
                        <th>Size</th>
                        <th className="text-right">PRICE</th>
                        <th className="text-right">QTY</th>
                        <th className="text-right">AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={jacket} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#jacket">Suede Biker Jacket</a>
                          <br />
                          <small>by Saint Laurent</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>3,390
                        </td>
                        <td className="td-number">1</td>
                        <td className="td-number">
                          <small>€</small>549
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={shirt} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#shirt">Jersey T-Shirt</a>
                          <br />
                          <small>by Balmain</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>499
                        </td>
                        <td className="td-number">2</td>
                        <td className="td-number">
                          <small>€</small>998
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={swim} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#pants">Slim-Fit Swim Short </a>
                          <br />
                          <small>by Prada</small>
                        </td>
                        <td>Red</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>200
                        </td>
                        <td className="td-number">3</td>
                        <td className="td-number">
                          <small>€</small>799
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5" />
                        <td className="td-total">Total</td>
                        <td className="td-price">
                          <small>€</small>2,346
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx